module.exports = __webpack_public_path__ + "static/img/login.7345478f.jpg";